<div>
  <div class="flex items-center justify-between " [ngClass]="{ 'h-[48px]': headerTitle }"
  >
    <h3 class="text-xl font-semibold">{{ headerTitle }}</h3>
    <ng-content select="[header-actions]"></ng-content>
  </div>
  <div>
    <ng-content select="[main-content]"></ng-content>
  </div>
</div>
